import { DataSource, Layout, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentManifestDetails extends Layout {
    sourcePartialShipmentManifestOrderDetails: DataSource;
    sourcePartialShipmentManifestStopDetails: DataSource;
    sourcePartialShipmentPlanningManifestProratedRevenue: DataSource;
    tabOrderDetails: Tab;
    tabStopDetails: Tab;
    tableOrderDetails: Table;
    tableStopTables: Table;
    tabsetManifestDetails: Tabset;
}
